import { render } from "./ModulesListDataTable.vue?vue&type=template&id=34845364"
import script from "./ModulesListDataTable.vue?vue&type=script&lang=js"
export * from "./ModulesListDataTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__